module.exports = __webpack_public_path__ + "img/banner.463c2b87.jpg";